<template>
  <h2
    class="section-title"
    :class="bem('section-title', { divider })"
  >
    <span
      class="section-title__title"
      v-text="title"
    />
    <span class="section-title__right">
      <slot />
    </span>
  </h2>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  export default {
    name: 'SectionTitle',
    props: {
      title: {
        type: String,
        required: true,
      },
      divider: Boolean,
    },
    methods: {
      bem,
    },
  };
</script>